module.exports = __webpack_public_path__ + "static/media/attach-docx.22fb2308.svg";